module.exports = "https://cdn-skillquest.mathletics.com/app/188/assets/images/f96ad259dac244792f540ed1575b2d8e.svg";